module.exports = __webpack_public_path__ + "8712e5ae4e7ce2e26fc8a755b8d989ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/bio-pic.jpg
// module id = 406
// module chunks = 1